import { CANAL, APP_VERSION } from "../helpers/constants";
import { axiosInstance, axiosInstanceSeguros } from "../helpers/axios";

const userAgent = window.navigator.userAgent;

const getCatalogos = (user, securitykey) => {
  return axiosInstance
    .post("getCatalogs/", {
      userAgent: userAgent,
      carrierCelular: userAgent,
      canal: CANAL,
      version: APP_VERSION,
      usuario: user,
      llaveSeguridad: securitykey,
    })
    .then((res) => {
      const data = res.data;
      return data;
    })
    .catch((err) => {
      console.log("error");
      console.log(err.message);
    });
};

const getCatalogosSeguros = (user, securitykey) => {
  // El header Authorization se agrega automáticamente mediante el interceptor de axios
  return axiosInstanceSeguros
    .post("getInsuranceCatalogs/", {
      userAgent: userAgent,
      carrierCelular: userAgent,
      canal: CANAL,
      version: APP_VERSION,
      usuario: user,
    })
    .then((res) => {
      const data = res.data;
      return data;
    })
    .catch((err) => {
      console.log("error");
      console.log(err.message);
      return err.response.status;
    });
};

export default { getCatalogos, getCatalogosSeguros };
